// extracted by mini-css-extract-plugin
export default {"player":"styles_player__Br-VL","avatar":"styles_avatar__ep5fy","alias":"styles_alias__mxB4v"};